import { useSyncExternalStore } from "react";
import { subscribe, getSnapshot } from "./webGmBridge";

/** Web GM live snapshot: { active, code, url, qrDataUrl, presence, votes }. */
export const useGmLive = () => useSyncExternalStore(subscribe, getSnapshot);

/**
 * Top-voted option for a group ("board" | "question" | "answer"), or null.
 * Returns { optionKey, count, total } — used for the glow badges on the
 * master's own controls.
 */
export const useGmTopVote = (group) => {
  const { active, votes } = useGmLive();
  if (!active || !votes || votes.group !== group || !votes.total) return null;

  let top = null;
  for (const [optionKey, count] of Object.entries(votes.counts)) {
    if (!top || count > top.count) top = { optionKey, count };
  }
  return top ? { ...top, total: votes.total } : null;
};
